<script setup lang="ts">
interface ChevronProps {
  color?: string;
  height?: string | number;
  width?: string | number;
}

withDefaults(defineProps<ChevronProps>(), {
  color: '#082f5b',
  height: 20,
  width: 20,
});
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 16 16" :fill="color">
    <path
      fill-rule="evenodd"
      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
    />
  </svg>
</template>
